import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AdminUserService } from '../../user/admin-user.service';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate {
  constructor(
    private adminUserService: AdminUserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (
      !this.adminUserService.isLogged() ||
      this.adminUserService.isTokenExpired()
    ) {
      this.router.navigate([route.params.companyToken + '/auth/login']);
    }

    return true;
  }
}
